import React from 'react';
import config from '../config';
import SectionReveal from '../components/SectionReveal';
import './About.css';

function About() {
  return (
    <main className="about-page">
      <section className="page-hero">
        <div className="container">
          <div className="page-hero__content">
            <span className="section-badge">About Us</span>
            <h1>Trust & Hygiene</h1>
            <p>Know the story behind every fresh fruit cup you enjoy.</p>
          </div>
        </div>
      </section>

      {/* Story */}
      <section className="section">
        <div className="container">
          <div className="about-story-grid">
            <SectionReveal animation="slideInLeft">
              <div className="about-story-images">
                <img src="/images/owner-prep.jpg" alt="FAL SUTRA preparation" className="about-story-img about-story-img--main" />
                <img src="/images/owner-cups.jpg" alt="FAL SUTRA cups" className="about-story-img about-story-img--small" />
              </div>
            </SectionReveal>
            <SectionReveal animation="slideInRight" delay={0.2}>
              <div className="about-story-content">
                <span className="section-badge">Our Story</span>
                <h2>Born from a Passion for Health</h2>
                <p>
                  FAL SUTRA was born out of a simple belief — everyone deserves access to fresh, nutritious food without compromise. We noticed that most people skip their daily fruits because of inconvenience, and we decided to change that.
                </p>
                <p>
                  Every morning at 4 AM, we source the freshest seasonal fruits from local farms. No cold storage, no preservatives, no shortcuts. Each cup is handcrafted with love, hygiene, and attention to detail.
                </p>
                <p>
                  From gym-goers to corporate professionals, our mission is simple — make healthy eating effortless, delicious, and accessible for everyone.
                </p>
              </div>
            </SectionReveal>
          </div>
        </div>
      </section>

      {/* Trust Pillars */}
      <section className="section about-trust-section">
        <div className="container">
          <SectionReveal>
            <div className="section-header">
              <span className="section-badge">Our Standards</span>
              <h2>Why You Can Trust Us</h2>
            </div>
          </SectionReveal>

          <div className="about-trust-grid">
            {[
              { icon: '🌾', title: 'Farm Fresh', desc: 'Daily sourcing at 4 AM. No cold storage. Only peak-fresh produce makes it to your cup.' },
              { icon: '🧤', title: 'Hygiene Certified', desc: 'FSSAI Registered. All processing in a sanitized environment with food-grade gloves and tools.' },
              { icon: '🚫', title: 'Zero Additives', desc: 'No sugar, no preservatives, no artificial colors. What you see is what nature created.' },
              { icon: '♻️', title: 'Eco-Friendly Packaging', desc: 'Wooden cutlery and recyclable cups. We care about your health AND the planet.' },
              { icon: '⚡', title: 'Made to Order', desc: 'Every cup is freshly cut upon order. No pre-prepared stock sitting in refrigerators.' },
              { icon: '🏅', title: 'FSSAI Licensed', desc: `License No: ${config.brand.fssaiLicense}. Fully compliant with food safety regulations.` },
            ].map((item, idx) => (
              <SectionReveal key={idx} delay={idx * 0.1}>
                <div className="about-trust-card">
                  <span className="about-trust-card__icon">{item.icon}</span>
                  <h3>{item.title}</h3>
                  <p>{item.desc}</p>
                </div>
              </SectionReveal>
            ))}
          </div>
        </div>
      </section>

      {/* Gallery */}
      <section className="section">
        <div className="container">
          <SectionReveal>
            <div className="section-header">
              <span className="section-badge">Gallery</span>
              <h2>Our Happy Moments</h2>
            </div>
          </SectionReveal>
          <div className="about-gallery">
            {[
              '/images/product-cup.jpg',
              '/images/fruit-cup-side.jpg',
              '/images/fruit-cup-top.jpg',
              '/images/gym-client1.jpg',
              '/images/gym-client2.jpg',
              '/images/gym-client3.jpg',
            ].map((img, idx) => (
              <SectionReveal key={idx} delay={idx * 0.08} animation="scaleIn">
                <div className="about-gallery__item">
                  <img src={img} alt={`FAL SUTRA moment ${idx + 1}`} />
                </div>
              </SectionReveal>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}

export default About;
